import { useState, useEffect } from "react";

function useStartTyping(): boolean {
  const [isTyping, setIsTyping] = useState(false);

  const handleStartTyping = () => {
    setIsTyping(true);
  };

  useEffect(() => {
    document.addEventListener("keydown", handleStartTyping);

    return () => {
      document.removeEventListener("keydown", handleStartTyping);
    };
  }, []);

  return isTyping;
}

export { useStartTyping };
